<template>
    <div
        class="w-full grid grid-cols-5 items-center justify-between text-slate-800"
        :class="{
            'opacity-60 cursor-not-allowed': props.disabled
        }"
    >
        <div class="col-span-4 grid items-center grid-cols-1 lg:grid-cols-3 gap-2">
            <div class="flex flex-col gap-1">
                <span class="line-clamp-3 w-full" :title="props.externalContactList.name">
                    {{ props.externalContactList.name }}
                </span>
            </div>

            <div data-test="external-contact-list-row-contact-count">
                <template v-if="props.contactsCount !== null && props.contactsCount !== undefined">
                    <font-awesome-icon widthAuto
                        :icon="faUser"
                        class="mr-1 text-slate-500 lg:hidden"
                    >
                    </font-awesome-icon>
                    {{ formatCount(props.contactsCount) }}
                </template>
                <font-awesome-icon widthAuto v-else :icon="faSpinnerThird" spin>
                </font-awesome-icon>
            </div>

            <div v-if="props.externalContactList.status === 'disconnected'" data-test="external-contact-list-row-status">
                <font-awesome-icon widthAuto
                    :icon="faLinkSlash"
                    class="text-slate-500 mr-1"
                ></font-awesome-icon>
                Disconnected
            </div>

        </div>
        <div class="text-right">
            <vx-button
                v-if="props.selected"
                type="button"
                color="muted"
                size="xs"
                :disabled="props.disabled"

            >
                Remove
            </vx-button>
            <vx-button
                v-else
                type="button"
                color="muted"
                size="xs"
                :disabled="props.disabled"
            >
                Add
                <font-awesome-icon widthAuto
                    class="text-xs ml-1"
                    :icon="faCirclePlus"
                ></font-awesome-icon>
            </vx-button>
        </div>
    </div>
</template>

<script setup>
import { VxButton } from '@voxie/frontend-components';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
    faCirclePlus,
    faUser,
    faLinkSlash,
} from "@fortawesome/pro-solid-svg-icons";
import { faSpinnerThird } from '@fortawesome/pro-regular-svg-icons';
import { formatNumber } from '~/utils/helpers';

const props = defineProps({
    externalContactList: {
        type: Object,
        required: true,
    },
    contactsCount: {
        type: Number,
        required: false,
    },
    selected: {
        type: Boolean,
        required: false,
    },
    disabled: {
        type: Boolean,
        default: false,
    }
});

const formatCount = (number) => {
    return number < 1000 ? formatNumber(number) : formatNumber(number, { notation: 'compact', minimumSignificantDigits: 3, maximumSignificantDigits: 3 });
}
</script>
